import { useQuery } from '@apollo/client';

import { useIdlePooling } from '@/hooks';
import { getManifests } from '@/api';
import { resolveGqlErrors } from '@/helpers';
import { DeliveryManifest } from '../types';

type UseManifestsTable = () => {
  loading: boolean;
  error?: string;
  manifests: DeliveryManifest[];
};

const useManifestsTable: UseManifestsTable = () => {
  const { data, error, loading, stopPolling, startPolling } = useQuery(getManifests);
  useIdlePooling({ startPolling, stopPolling });

  const manifests = data?.getTodayDeliveryManifests?.deliveryManifests || [];

  return {
    loading,
    error: resolveGqlErrors(error || data?.getTodayDeliveryManifests?.error),
    manifests,
  };
};

export default useManifestsTable;
